export default __webpack_public_path__ + "static/media/document-home-icon.b0cfecaa.png";